import { CalculationError } from '@hb/domain';

import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';

export class MortgageCalculationError {
    message: string;
    isCalculationError: boolean;

    constructor(error: string, isCalculationError: boolean) {
        this.message = error;
        this.isCalculationError = isCalculationError;
    }
}

@Injectable({
    providedIn: 'root'
})
export class ErrorService {
    private readonly errorSubject: Subject<MortgageCalculationError> = new Subject();

    publish(errorResponse: HttpErrorResponse) {
        if (errorResponse && errorResponse.error) {
            this.errorSubject.next(
                new MortgageCalculationError(errorResponse.error.detail, this.isCalculationError(errorResponse.error.detail))
            );
        } else {
            this.errorSubject.next(null);
        }
    }

    private isCalculationError(error: string): boolean {
        return error === CalculationError.INCOME_FINANCIAL_OBLIGATION || error === CalculationError.EXTRA_ASSET;
    }

    /**
     * @returns stream of all errors.
     */
    public error$(): Observable<MortgageCalculationError> {
        return this.errorSubject;
    }
}
